import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getRule (params = null, cancellationToken = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getUser)
    })
  } else {
    const req = {
      url: '/api/reglas/getregladetalle',
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      params,
      cancelToken: cancellationToken?.token,
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getRule }
